import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchHQLocationType } from "../../../domain/models/user-hq-location-dashboard/fetch-hq-location";
import { FetchHQLocation } from "../../../domain/useages/user-hq-location-dashboard/fetch-hq-location-data";
import { RemoteFetchHQLocation } from "../../../data/usecases/user-hq-location-dashboard/remote-fetch-hq-location";

export interface FetchHQLocationInterface {
  FetchHQLocation: FetchHQLocationType;
  FetchHQLocationState: FetchState;
  fetchHQLocation: Function;

}

const initialStates = {
  FetchHQLocation: {} as FetchHQLocationType,
  FetchHQLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchHQLocationSlice: StateCreator<
 FetchHQLocationInterface
> = (set) => ({
  ...initialStates,
  fetchHQLocation: async (
    filter: FetchHQLocation.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchHQLocation = new RemoteFetchHQLocation(
      `${BASE_URL}${Endpoints.FETCH_HQ_LOCATION}`,
      axiosHttpClient
    );

    set(() => ({ FetchHQLocationState: FetchState.LOADING }));
    let result = await remoteFetchHQLocation.fetch(filter);
    return result;
  },
});
